import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

const ROW_HEIGHT = 64;

type ColumnProps = {
  expand?: boolean;
  expandOnMobile?: boolean;
};

export const Column = styled.td<ColumnProps>(
  props => css`
    height: ${ROW_HEIGHT}px;

    > a,
    > button {
      padding: 0 10px;
      ${media.smallOnly`
      padding: 0 2px;
    `}
    }
    > .pj-ui-popover--wrapper {
      display: block;
      width: 100%;
      height: 100%;
    }
    ${props.expandOnMobile &&
      media.mediumDown`
      width: 100%;
    `}
    ${props.expand &&
      css`
        width: 100%;
      `}
  `
);

type LinkProps = {
  alignCenter?: boolean;
  alignLeft?: boolean;
  alignRight?: boolean;
  vertical?: boolean;
};

export const Link = styled.a<LinkProps>(
  props => css`
  display: flex;
  align-items: center;
  min-height: 100%;
  width: 100%;
  outline: none;

  ${props.alignCenter &&
    css`
      justify-content: center;
    `}
  ${props.alignLeft &&
    css`
      justify-content: flex-start;
    `}
  ${props.alignRight &&
    css`
      justify-content: flex-end;
    `}
    
`
);

type SharedRowProps = {
  noExternalUri?: boolean;
  nonFeatured?: boolean;
  showReport?: boolean;
};

const rowStyles = css`
  width: 100%;
  line-height: 1.3em;
  position: relative;
  > td {
    border-bottom: 1px solid ${p => p.theme.lines.primary};
  }

  ${(props: SharedRowProps) =>
    props.noExternalUri &&
    css`
      cursor: default;
    `}

  ${props =>
    props.nonFeatured &&
    css`
      color: ${p => p.theme.text.secondary};
      &:hover {
        color: ${p => p.theme.text.secondary};
      }
    `}

  ${media.smallOnly`
      &:last-child {
        border-bottom: 1px solid ${p => p.theme.lines.primary};
      }
    }
  `}
`;

type RowExperimentProps = {
  expanded?: boolean;
};

export const Row = styled.tr<SharedRowProps & RowExperimentProps>(
  props => css`
    ${rowStyles}

    > td {
      ${props.showReport &&
        css`
          border-bottom: 1px solid ${props.theme.colors.base0};
        `}
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }

    ${props.expanded &&
      css`
        box-shadow: 0 6px 5px -5px rgba(0, 0, 0, 0.2);
      `}
  `
);

export const InfoRow = styled.tr`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
  > td {
    flex: 0 0 100%;
  }
`;

export const AltRow = styled.tr`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

type ReportRowProps = {
  isAlternative?: boolean;
};

export const ReportRow = styled.tr<ReportRowProps>`
  ${rowStyles}
`;

export const AltReportRow = styled.tr`
  ${rowStyles}
  background-color: rgba(0, 0, 0, 0.03);
`;
